export default {
  nav: {
    home: 'ホーム',
    about: '会社概要',
    philosophy: '経営理念',
    business: '事業内容',
    news: 'ニュース',
    contacts: 'お問合せ',
    getQuote: 'お見積もり',
    getAQuote: 'お見積もり依頼',
    openMenu: 'メニューを開く',
    closeMenu: 'メニューを閉じる',
  },
};
